import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { AuthContextStorageService } from '../../../../core/auth/auth-context-storage.service'
import { SubjectContactPaymentDataControllerService } from '../../../../api/backend'
import { ConcernedDatastoreService } from '../../../../domain/subject/services/concerned-datastore.service'

@Component({
    selector: 'ca-payment-concerned-autofill',
    templateUrl: './payment-concerned-autofill.html',
})
export class PaymentConcernedAutofillComponent implements OnInit {

    @Output() callback = new EventEmitter<any>()
    @Output() close = new EventEmitter<any>()

    concernedSubjects = []
    concernedBankAccounts = []
    concernedSubjectsListString = ''

    constructor(@Inject(ConcernedDatastoreService) private concernedDatastore: ConcernedDatastoreService,
                @Inject(SubjectContactPaymentDataControllerService) private scpdControllerService: SubjectContactPaymentDataControllerService,
                @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService,
                ) {
    }

    ngOnInit() {
        this.concernedDatastore.getAllConcerned().then(subjects => {
            if (subjects) {
                subjects = subjects.filter(concerned => concerned.subject?.id)
                this.concernedSubjects = subjects
                const concernedSubjectList = []
                subjects.forEach(concerned => {
                    // platební údaje je potřeba načítat pokaždé samostatně, protože v concernedSubjects se načítají jen při inicializaci aplikace
                    this.scpdControllerService.getAllContactPaymentData(this.authContextStorageService.getProjectKey(), concerned.subject.contactId).subscribe(paymentData => {

                        if (paymentData.items?.length) {
                            paymentData.items.forEach(payment => {
                                if (payment.paymentMethod === 'B' && payment.bankCode) {
                                    payment.bankName = this.removeAbbreviations(payment.bankName)
                                    this.concernedBankAccounts.push({...payment, 'name': this.removeAbbreviations(concerned.name)})
                                }
                            })
                        }
                        concernedSubjectList.push(this.removeAbbreviations(concerned.name))
                        this.concernedSubjectsListString = concernedSubjectList.join(', ')
                    })
                })
            }
        })
    }

    fillAccountDetails(paymentDetails): void {
        this.callback.emit({$paymentDetails: paymentDetails})
    }

    closeDialog(): void {
        this.close.emit()
    }

    private removeAbbreviations(text): string {
        if (!text) {
            return text
        }
        text = text.replace(/\,? a\.\s?s\./g, ' ')
        text = text.replace(/\,? (spol\.\s)?s\.?\s?r\.\s?o\./g, ' ')
        text = text.replace(/\s+/g, ' ')
        return text.trim()
    }

}
